export class TableBookingOrder {
    constructor(
        public partySize: number,
        public bookableIds: string[]
    ) { }
}

export class BookingAssignment {
    constructor(
        public tableOrders: TableBookingOrder[] = []
    ) { }
}
